// extracted by mini-css-extract-plugin
export var container = "styles-module--container--2e949";
export var content = "styles-module--content--d5359";
export var header = "styles-module--header--28f27";
export var sider = "styles-module--sider--2d7c4";